import isNil from 'lodash/isNil'
import React from 'react'

import TypeString from '#/components/FormatCell/Types/string'
import { minutesToHours } from '#/utils'

const TypeMinutesToHours = ({ value }) => {
  if (isNil(value)) return <span>-</span>

  return <TypeString value={`${value}/${minutesToHours(value)}`} />
}
export default TypeMinutesToHours
